export const locale = {
  lang: 'sp',
  data: {
    MENU: {
      HOME: 'Inicio',
      SAMPLE: 'Ejemplo',
      BITSO: 'Bitso',
      PRONOSTICO: 'Pronostico'
    }
  }
}
